export default __webpack_public_path__ + "static/Druid-303cb81c3b3494c9aebbc8e353787bff.png";